/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {calculateLineItems} from '../api'

export const useMutationCalculateLineItems = createReactQueryMutationHook('calculateLineItems', calculateLineItems)
